import { render, staticRenderFns } from "./PzFilter.vue?vue&type=template&id=3d6c8cb8&"
import script from "./PzFilter.vue?vue&type=script&lang=js&"
export * from "./PzFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports